"use strict";
// acss_debit;
// affirm;
// afterpay_clearpay;
// alipay;
// au_becs_debit;
// bacs_debit;
// bancontact;
// blik;
// boleto;
// card;
// customer_balance;
// eps;
// fpx;
// giropay;
// grabpay;
// ideal;
// klarna;
// konbini;
// link;
// oxxo;
// p24;
// paynow;
// promptpay;
// sepa_debit;
// sofort;
// us_bank_account;
// wechat_pay;
Object.defineProperty(exports, "__esModule", { value: true });
exports.translateStripePaymentMethod = translateStripePaymentMethod;
exports.translateInventoryOperation = translateInventoryOperation;
exports.translateInventoryOperationShortDescription = translateInventoryOperationShortDescription;
const useful_1 = require("./useful");
function translateStripePaymentMethod(method) {
    switch (method) {
        case 'acss_debit':
            return 'ACSS Debit';
        case 'affirm':
            return 'Affirm';
        case 'afterpay_clearpay':
            return 'Afterpay Clearpay';
        case 'alipay':
            return 'Alipay';
        case 'au_becs_debit':
            return 'Australian BECS Debit';
        case 'bacs_debit':
            return 'BACS Debit';
        case 'bancontact':
            return 'Bancontact';
        case 'blik':
            return 'BLIK';
        case 'boleto':
            return 'Boleto';
        case 'card':
            return 'Card';
        case 'customer_balance':
            return 'Customer Balance';
        case 'eps':
            return 'EPS';
        case 'fpx':
            return 'FPX';
        case 'giropay':
            return 'Giropay';
        case 'grabpay':
            return 'GrabPay';
        case 'ideal':
            return 'iDeal';
        case 'klarna':
            return 'Klarna';
        case 'konbini':
            return 'Konbini';
        case 'link':
            return 'Link';
        case 'oxxo':
            return 'OXXO';
        case 'p24':
            return 'P24';
        case 'paynow':
            return 'PayNow';
        case 'promptpay':
            return 'PromptPay';
        case 'sepa_debit':
            return 'SEPA Debit';
        case 'sofort':
            return 'Sofort';
        case 'us_bank_account':
            return 'US Bank Account';
        case 'wechat_pay':
            return 'WeChat Pay';
        default:
            return (0, useful_1.capitalize)(method);
    }
}
function translateInventoryOperation(operation) {
    switch (operation) {
        case 'MANAGER':
            return 'Manual Adjustment';
        case 'PURCHASE':
            return 'Purchase';
        case 'TRANSFER':
            return 'Warehouse Transfer';
        case 'RECYCLE':
            return 'Recycle';
        case 'DUMP':
            return 'Dump';
        case 'DONATION':
            return 'Donation';
        case 'PICKUP':
            return 'Pickup';
        case 'DROPOFF':
            return 'Dropoff';
        case 'BULK_INTAKE':
            return 'Bulk Intake';
        case 'DELIVERY':
            return 'Delivery';
    }
}
function translateInventoryOperationShortDescription(operation) {
    switch (operation) {
        case 'MANAGER':
            return 'Inventory Manager Adjustment';
        case 'PURCHASE':
            return 'Inventory Purchase from Supplier';
        case 'TRANSFER':
            return 'Inventory transfer between warehouses';
        case 'RECYCLE':
            return 'Inventory recycled';
        case 'DUMP':
            return 'Inventory dumped';
        case 'DONATION':
            return 'Inventory donated (not delivery)';
        case 'PICKUP':
            return 'Inventory picked up from donor';
        case 'DROPOFF':
            return 'Inventory dropped off by Donor';
        case 'BULK_INTAKE':
            return 'Bulk donation from partner';
        case 'DELIVERY':
            return 'Delivery to client';
    }
}
